export default function () {
  this.loadSpecializations()
}
